export default "__VITE_ASSET__BJkXEnRy__"